module.exports = __webpack_public_path__ + "img/AdobeStock_33145817.af37888f.jpeg";